import React from "react";
import { ITable, ICSSProps, ColorProps, PrimaryColor, SubColor } from "@gago/frame";
import styled from "styled-components";
import tinycolor from "tinycolor2";
// tslint:disable: jsx-no-multiline-js
// tslint:disable-next-line: variable-name
const Root = styled.div<ColorProps<PrimaryColor>>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .row:nth-child(odd){
    background-image: linear-gradient(
      to right,
      ${p => tinycolor(p.colorPalette.mainColor[2]).setAlpha(0).toRgbString()} 0%,
      ${p => tinycolor(p.colorPalette.mainColor[2]).setAlpha(0.08).toRgbString()} 96%
    );
  }
  .row{
    display: flex;
    flex: 0 0 34px;
    width: 100%;
    align-items: center;
    justify-content: left;
    .col0{
      flex: 0 0 32px;
      .dot{
        width: 8px;
        height: 8px;
        border-radius: 4px;
        margin: auto;
      }
    }
    .col1{
      color: ${p => p.colorPalette.mainColor[3]};
      font-size: 14px;
      flex: 1 1 10px;
    }
    .col2{
      color: ${p => p.colorPalette.mainColor[1]};
      font-size: 18px;
      flex: 0 0 40px;
      text-align: right;
      padding: 0 4px;
      font-family: BebasNeue;
    }
    .col3{
      color: ${p => p.colorPalette.mainColor[1]};
      font-size: 14px;
      flex: 0 0 44px;
      padding: 0 16px 0 0;
      text-align: left;
    }
    .col4{
      color: ${p => p.colorPalette.mainColor[1]};
      font-size: 18px;
      flex: 0 0 28px;
      padding: 0 16px 0 0;
      font-family: BebasNeue;
      position: relative;
      .line{
        background-color: ${p => tinycolor(p.colorPalette.mainColor[2]).setAlpha(0.25).toRgbString()};
        width: 1px;
        height: 12px;
        position: absolute;
        left: -8px;
        top: 7px;
      }
    }
  }
`;

// tslint:disable-next-line: variable-name
const Dot = styled.div<{ color: string }>`
  background-color: ${p => p.color};
`;

export interface PieChartLegendProps extends ICSSProps, ColorProps<PrimaryColor & SubColor> {
  /** 表格数据 */
  data: ITable<3 | 4, 0>["data"];
}

/** 饼图图例
 * @author James Zhang
 */
// tslint:disable-next-line: naming-convention
export function PieChartLegend(props: PieChartLegendProps) {
  return (
    <Root
      className={props.className}
      style={props.style}
      colorPalette={props.colorPalette}
    >
      {props.data.map((item, index) => (
        <div key={index} className="row">
          <div className="col col0">
            <Dot className="dot" color={props.colorPalette.subColor[index]} />
          </div>
          <div className="col col1">{item[1]}</div>
          <div className="col col2">{item[2]}</div>
          <div className="col col3">{item[3]}</div>
          {item[4] && (<div className="col col4"><div className="line" />{item[4]}</div>)}
        </div>
      ))}
    </Root>
  );
}
